import { DEFAULT_SESSION_LIFETIME } from "./defaultSessionLifetime";
import { REMEMBER_ME_COOKIE_KEY } from "./rememberMeCookieKey";
import { SDK_NOT_CONFIGURED_ERROR_MESSAGE } from "./sdkNotConfiguredErrorMessage";

export {
	DEFAULT_SESSION_LIFETIME,
	REMEMBER_ME_COOKIE_KEY,
	SDK_NOT_CONFIGURED_ERROR_MESSAGE,
};
